<main>
    <section class="form-wrapper">
        <section class="step">
            <form [formGroup]="form" class="form">

                <div class="section section--three-1">

                    <mat-form-field appearance="outline" class="Input Input--select Input--suffix"
                        [class.Input--readonly]="form.disabled">
                        <mat-label>Unidad</mat-label>
                        <input type="text" matInput formControlName="plate">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="Input" [class.Input--readonly]="form.disabled">
                        <mat-label>VIN</mat-label>
                        <input type="text" matInput formControlName="vin">
                    </mat-form-field>

                </div>

                <div class="section section--three-2">

                    <mat-form-field appearance="outline" class="Input" [class.Input--errors]="
                thirdFormHasError('acountable', 'required') ||
                thirdFormHasError('acountable', 'pattern')
            " [class.Input--readonly]="form.disabled">

                        <mat-label>Persona que realizará el servicio de rebalanceo</mat-label>
                        <input type="text" matInput formControlName="acountable">

                        @if (thirdFormHasError('acountable', 'required')) {
                        <mat-error class="ErrorMessage">El responsable es obligatorio</mat-error>
                        }

                        @if (thirdFormHasError('acountable', 'pattern')) {
                        <mat-error class="ErrorMessage">El nombre solo debe contener letras</mat-error>
                        }
                    </mat-form-field>

                </div>

                <div class="section section--three-3">

                    <label>¿Se ha hecho efectivamente el rebalanceo?</label>
                    <mat-radio-group color="primary" formControlName="rebalancing_ok"
                        [class.Input--readonly]="form.disabled">
                        <mat-radio-button [checked]="form.get('rebalancing_ok')?.value" [value]="true">Sí
                        </mat-radio-button>
                        <mat-radio-button [checked]="!form.get('rebalancing_ok')?.value" [value]="false">No
                        </mat-radio-button>
                    </mat-radio-group>


                    <div class="section__upload">
                        <app-button color="green" [hasIcon]="true" [isDisabled]="isDisabled" [isFull]="true"
                            (clicked)="rear_mobile_camera.click()">
                            Tomar foto
                            <app-icon appIcon [icon]="EIcons.photo_camera" iconSize="normal"
                                [iconMoveTopToBotton]="3" />
                        </app-button>

                        <input type="file" style="display: none;" #rear_mobile_camera accept="image/*" capture="camera"
                            (change)="setFiles($event, files)" />

                        <app-button color="green" [hasIcon]="true" [isDisabled]="isDisabled" (clicked)="files.click()">
                            Subir foto
                            <app-icon appIcon [icon]="EIcons.publish" iconSize="normal" [iconMoveTopToBotton]="3" />
                        </app-button>

                        <input type="file" style="display: none;" #files accept="image/*"
                            (change)="setFiles($event, files)">
                    </div>

                    @if (previewImage()) {
                    <div class="section__preview">
                        <img [src]="previewImage()" alt="rebalancing preview">
                    </div>
                    }
                </div>

                <div class="section section--three-4">
                    <mat-form-field appearance="outline" class="Input Input--textarea"
                        [class.Input--readonly]="form.disabled">
                        <mat-label>Observaciones</mat-label>
                        <textarea matInput formControlName="obs" rows="3"></textarea>
                    </mat-form-field>
                </div>

                <footer>
                    <app-button [isFull]="true" (clicked)="save()" [isDisabled]="form.invalid || isDisabled">
                        Finalizar
                    </app-button>
                </footer>
            </form>
        </section>
    </section>
</main>